import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { UserListRequestParams } from '@/types/user.type'

// http://playable.dev.com:8067/?doc=system/api%2fuser%2fuser.go

export function fetchUserList(params: UserListRequestParams) {
  return request({
    url: `${v2Host}/system/user/list`,
    method: 'get',
    params
  })
}

export function searchUserList(params: UserListRequestParams) {
  return request({
    url: `${v2Host}/system/user/search`,
    method: 'get',
    params
  })
}
